/**
 * Legal and checkout settings for this site: what the policies say is sold,
 * the name on card statements, the terms version recorded with every purchase,
 * and the colours of the agreement box and the confirmation screen.
 * Used by config/legalContent.ts, pages/LegalPage.tsx and components/legal/*.
 */

import { SUPPORT_EMAIL, SITE_DOMAIN } from './brandConfig'

/** Recorded with every purchase. Move both forward whenever the wording changes. */
export const TERMS_VERSION = '2026-09-25'
export const TERMS_UPDATED = 'September 25, 2026'

export const LEGAL = {
  siteTitle: 'Caryn',
  creator: 'Caryn',
  domain: SITE_DOMAIN,
  supportEmail: SUPPORT_EMAIL,
  /** How charges appear on the fan's card statement (the Stripe account's descriptor). */
  statementName: 'CARYN MARJORIE LLC',
  refundDays: 14,
  offer: {
    renews: true as boolean,
    name: 'Full Private Access',
    price: '',
    length: '',
    endsAfter: '',
    days: 30,
    welcome: 'Welcome! Your membership is active.',
    checklist: ['Access to all content', 'New updates included', 'Cancel anytime in Account'],
    chargeLine: '',
  },
}

export const LEGAL_STYLE = {
  checkbox: 'accent-pink-600',
  link: 'font-medium text-pink-700 underline underline-offset-2',
  check: 'text-green-600',
  button: 'bg-pink-600 hover:bg-pink-700 text-white',
}
